import { render, staticRenderFns } from "./MainNavTitle.vue?vue&type=template&id=64721414&"
import script from "./MainNavTitle.vue?vue&type=script&lang=js&"
export * from "./MainNavTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MainNavTitle.vue"
export default component.exports